import React from 'react';
import { ExpandToggle } from './expand-toggle';
import { Search } from './search';
import { SyntaxHelp } from './syntax-help';
import { useEditorThemeContext } from '../../hooks/use-editor-theme';
export var JQLEditorControlsContent = function JQLEditorControlsContent() {
  var _useEditorThemeContex = useEditorThemeContext(),
      isSearch = _useEditorThemeContex.isSearch;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExpandToggle, null), /*#__PURE__*/React.createElement(SyntaxHelp, null), isSearch && /*#__PURE__*/React.createElement(Search, null));
};